var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 19,
    viewBox: "0 0 31 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.27 16.288C9.77891 16.288 5.15108 13.4824 2.23146 9.162C5.15108 4.84161 9.77891 2.036 15.27 2.036C20.7611 2.036 25.3889 4.84161 28.3085 9.162C25.3889 13.4824 20.7611 16.288 15.27 16.288ZM15.27 0C8.77109 0 3.37162 3.47342 0.154738 8.62246C0.0536177 8.78425 0 8.97121 0 9.162C0 9.35279 0.0536177 9.53975 0.154738 9.70154C3.37162 14.8506 8.77109 18.324 15.27 18.324C21.7689 18.324 27.1684 14.8506 30.3853 9.70154C30.4864 9.53975 30.54 9.35279 30.54 9.162C30.54 8.97121 30.4864 8.78425 30.3853 8.62246C27.1684 3.47342 21.7689 0 15.27 0ZM15.27 13.234C16.35 13.234 17.3857 12.805 18.1493 12.0413C18.913 11.2777 19.342 10.242 19.342 9.162C19.342 8.08204 18.913 7.04631 18.1493 6.28266C17.3857 5.51901 16.35 5.09 15.27 5.09C14.19 5.09 13.1543 5.51901 12.3907 6.28266C11.627 7.04631 11.198 8.08204 11.198 9.162C11.198 10.242 11.627 11.2777 12.3907 12.0413C13.1543 12.805 14.19 13.234 15.27 13.234Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/EyeOpen.f2fa8f5b82cdb7e7a2d37f820084393e.svg";
export { ForwardRef as ReactComponent };